import { axios } from '@/lib/axios';

import { UserResponse } from '../types';
import storage from '@/utils/storage';
export type LoginCredentialsDTO = {
  code?: string;
  redirect_uri?: string;
  scope?: string;
  client_id?: string;
  timezone?: string;
  businessId?: number;
  token?: string;
  isAddCalender?: boolean;
  isLinkCalender?: boolean;
  type?: string;
  userData?: UserResponse;
  email?: string;
  password?: string;
  otp?: string;
};

export const loginWithGoogle = (data: LoginCredentialsDTO): Promise<UserResponse> => {
  if (data.isAddCalender) {
    const authorization = storage.getToken();

    return axios.get(`/business/calendar/add/google`, {
      params: data,
      headers: { authorization },
    });
  } else if (data.isLinkCalender) {
    const authorization = storage.getToken();

    return axios.get(`/business/calendar/link/google`, {
      params: data,
      headers: { authorization },
    });
  } else {
    const token = data.token;
    delete data.token;
    if (data.type && data.type == 'microsoft') {
      if (token) {
        return axios.get(`/auth/microsoft`, {
          params: data,
          headers: { invite_token: token },
        });
      } else {
        return axios.get(`/auth/microsoft`, {
          params: data,
        });
      }
    } else {
      if (token) {
        return axios.get(`/auth/google`, {
          params: data,
          headers: { invite_token: token },
        });
      } else {
        return axios.get(`/auth/google`, {
          params: data,
        });
      }
    }
  }
};
export const saveFCMToken = (): Promise<{ fcmToken: string; businessUserId: string }> => {
  let obj = {};
  if (storage.getFCMToken('fcmToken')) {
    if (
      storage.getToken() &&
      storage.getFCMToken('oldFcmToken') &&
      storage.getFCMToken('fcmToken') != storage.getFCMToken('oldFcmToken')
    ) {
      obj = {
        fcmToken: storage.getFCMToken('fcmToken'),
        oldFcmToken: storage.getFCMToken('oldFcmToken'),
      };
    } else {
      obj = { fcmToken: storage.getFCMToken('fcmToken') };
    }
    return axios.post(`/fcm/business/user/token/update`, obj);
  } else {
    return new Promise<{ fcmToken: string; businessUserId: string }>((resolve, reject) => {
      reject();
    });
  }
};


export const loginWithEmailId = (data: LoginCredentialsDTO): Promise<UserResponse> => {
  return axios.post('/business/email/login', data);
};